<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动管理</span>
          <el-form ref="queryForm" style="margin-top: 10px" :model="queryParams" :inline="true">
            <el-form-item label="活动名称" prop="name">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入活动名称"
                clearable
                size="small"
                style="width: 160px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="queryParams.isOnline"
                placeholder="状态"
                clearable
                size="small"
                style="width: 160px"
              >
                <el-option
                  v-for="dict in statusType"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="活动分类" prop="status">
              <el-select
                v-model="queryParams.type"
                filterable
                placeholder="活动分类"
                clearable
                size="small"
                style="width: 160px"
              >
                <el-option
                  v-for="dict in types"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="活动类型" prop="status">
              <el-select
                v-model="queryParams.ucType"
                placeholder="活动类型"
                clearable
                size="small"
                style="width: 160px"
              >
                <el-option
                  v-for="dict in actType"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                v-model="queryParams.startTime"
                type="datetime"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item label="结束时间" prop="startTime">
              <el-date-picker
                v-model="queryParams.endTime"
                type="datetime"
                placeholder="选择日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
              <el-button
                v-permisaction="['config:activityCoins:add']"
                type="primary"
                icon="el-icon-plus"
                size="mini"
                style=""
                @click="edit(0)"
              >新增</el-button>
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="importUploadSuccess"
                :headers="headers"
                style="display: inline-block;margin-left: 10px"
              >
                <el-button v-if="queryParams.type" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >

          <el-table-column
            prop="id"
            label="活动ID"
            align="center"
            width="150"
          />

          <el-table-column
            prop="name"
            label="活动名称"
            align="center"
          />

          <el-table-column
            prop="type"
            label="活动分类"
            :formatter="typeFormatter"
            align="center"
          />

          <el-table-column
            prop="type"
            label="活动类型"
            :formatter="ucTypeFormatter"
            align="center"
          />

          <el-table-column
            prop="imgNameStr"
            label="皮肤"
            align="center"
          />

          <!--          <el-table-column-->
          <!--            prop="loop_num"-->
          <!--            label="循环周期"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="loopTime"-->
          <!--            label="生效时间"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="user_level_section"-->
          <!--            label="等级范围"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="user_vip_section"-->
          <!--            label="Vip等级区间"-->
          <!--            align="center"-->
          <!--            width="150"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="user_score_section"-->
          <!--            label="分数区间"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="cid"-->
          <!--            label="收集物品id"-->
          <!--            width="100"-->
          <!--            align="center"-->
          <!--          />-->

          <el-table-column
            prop="start_time"
            label="开始时间"
            align="center"
          />

          <el-table-column
            prop="end_time"
            label="结束时间"
            align="center"
          />

          <el-table-column
            prop="is_online"
            label="状态"
            align="center"
          >
            <template slot-scope="props">
              <el-tag v-if="props.row.is_online === 0" type="danger">下线</el-tag>
              <el-tag v-if="props.row.is_online === 1">上线</el-tag>
            </template>
          </el-table-column>

          <!--          <el-table-column-->
          <!--            prop="lock_time"-->
          <!--            label="关闭时间"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="reward_time"-->
          <!--            label="领奖时间"-->
          <!--            width="160"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="client"-->
          <!--            label="客户端类型"-->
          <!--            width="100"-->
          <!--            align="center"-->
          <!--            :formatter="clientFormatter"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="user_type"-->
          <!--            label="用户类型"-->
          <!--            width="100"-->
          <!--            align="center"-->
          <!--            :formatter="userTypeFormatter"-->
          <!--          />-->

          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="300"
          >
            <template slot-scope="scope">
              <el-button v-permisaction="['config:activityIndex:copy']" type="text" size="mini" @click="copy(scope.row.id)">拷贝</el-button>
              <el-button v-permisaction="['config:activityIndex:edit']" type="text" size="mini" @click="edit(scope.row.id,scope.row.is_online )">编辑</el-button>
              <el-button v-if="scope.row.id > 0" v-permisaction="['config:activityIndex:config']" type="text" size="mini" @click="reward(scope.row.type,scope.row.id,scope.row.uc_type,scope.row.is_online )">配置</el-button>
              <el-button v-if="scope.row.is_online === 0" v-permisaction="['config:activityIndex:isOnline']" :disabled="scope.row.is_change == 0" type="text" size="mini" @click="changeOnline(scope.row.id,1,scope.row.type,scope.row.priority)">上线</el-button>
              <el-button v-if="scope.row.is_online === 1" v-permisaction="['config:activityIndex:isOnline']" type="text" size="mini" @click="changeOnline(scope.row.id,0,scope.row.type,scope.row.priority)">下线</el-button>
              <el-button v-permisaction="['config:activityIndex:isOnline']" type="text" size="mini" @click="exportData(scope.row.id,scope.row.type)">导出</el-button>
              <!--              <el-upload-->
              <!--                ref="stage-coefficient"-->
              <!--                class="upload-demo"-->
              <!--                :action="sys_app_logoAction"-->
              <!--                accept="xlsx"-->
              <!--                :limit="1"-->
              <!--                :on-success="v=>importStageCoefficientUploadSuccess(v,scope.row.id)"-->
              <!--                :headers="headers"-->
              <!--                style="display: inline-block;margin-left: 10px"-->
              <!--              >-->
              <!--                <el-button v-permisaction="['config:rewardRankEdit:import']" :loading="loading" size="mini" type="text">系数导入</el-button>-->
              <!--              </el-upload>-->
              <!--              <el-button v-permisaction="['config:activityIndex:isOnline']" type="text" size="mini" @click="exportStageCoefficient(scope.row.id)">系数导出</el-button>-->
              <el-button v-permisaction="['config:activityIndex:del']" :disabled="scope.row.is_online === 1 || scope.row.uc_type === 1" type="text" size="mini" @click="del(scope.row.id,scope.row.type,scope.row.priority)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  changeActivtyOnline,
  copyActivtyData,
  delActivtyCfg, exportActivtyRewardCfg, exportStageCoefficientCfg,
  getActivtyList,
  getActivtyTypesList, importActivtyRewardCfg, importActivtyStageCoefficientCfg
} from '@/api/config/activity-cfg'
export default {
  name: 'ActivityConfig',
  data() {
    return {
      loading: false,
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        name: '',
        type: '',
        ucType: '',
        isOnline: '',
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [],
      types: [],
      statusType: [
        { label: '上线', value: 1 },
        { label: '下线', value: 0 }
      ],
      actType: [
        { label: '普通活动', value: 0 },
        { label: '道具活动', value: 1 }
      ],
      coupon_skin: [
        { label: '默认', value: '0' },
        { label: '披萨', value: '1' }
        // { label: '沙滩冲浪', value: '2' },
        // { label: '放风筝', value: '3' }
      ]
    }
  },
  created() {
    this.getTables()
    this.getActivtyTypes()
    this.$root.$on('fetchData', this.fetchData)
  },
  methods: {
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      this.queryParams.pageSize = 10
      this.queryParams.pageIndex = 1
      this.$store.dispatch('queryForm/activityConfigForm', {
        value: this.queryParams
      })
      this.getTables()
    },
    fetchData() {
      this.getTables()
    },
    beforeDestroy() {
      this.$root.$off('fetchData', this.fetchData) // 取消监听 fetchData 事件
    },
    getActivtyTypes() {
      getActivtyTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.types.push({ label: val, value: i })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.queryParams = this.$store.state.queryForm.activityConfigForm
      getActivtyList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    copy(id) {
      copyActivtyData({ id: id }).then(res => {
        if (res.code === 200) {
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    edit(id, is_online) {
      this.$router.push({ name: 'ActivityConfigEdit', query: { id: id, rule: 0, is_online: is_online }})
    },
    reward(type, id, uc_type, is_online) {
      const returnUrl = { name: '', query: { id: id, type: type, uc_type: uc_type, is_online: is_online }}
      const routeMap = {
        'super_collect': 'RewardCollectEdit',
        'super_collect2': 'RewardCollectEdit',
        'super_collect3': 'RewardCollectEdit',
        'rank': 'RewardRankEdit',
        'super_serial_pack': 'RewardSerialPack',
        'super_serial_pack2': 'RewardSerialPack',
        'super_serial_pack3': 'RewardSerialPack',
        'super_serial_pack4': 'RewardSerialPack',
        'coin_blast': 'RewardCoinBlastEdit',
        'shop_promotion': 'RewardShopPromotionEdit',
        'traffic_permit': 'rewardTrafficPermitEdit',
        'traffic_permit2': 'rewardTrafficPermitEdit',
        'traffic_permit3': 'rewardTrafficPermitEdit',
        'spins_master': 'RewardSpinsMasterEdit',
        'build_pack': 'rewardBuildPackEdit',
        'easter_egg': 'RewardEggEdit',
        'super_balloon': 'RewardSuperBalloonEdit',
        'architecture': 'RewardBuilderMasterEdit',
        'pick_one': 'RewardPickOneEdit',
        'choose_one': 'rewardChooseOneEdit',
        'one_plus_gift': 'RewardOnePlusGiftEdit',
        'two_plus_gift': 'RewardTwoPlusGiftEdit',
        'exchange_store': 'RewardExchangeStoreEdit',
        'golden_card_trade': 'RewardGoldenCardTradeEdit',
        'crazy_card_group': 'CrazyCardGroup',
        'crazy_bet': 'CrazyBet',
        'super_bomb': 'RewardSuperBombEdit',
        'perfect_steal': 'RewardPerfectStealEdit',
        'download_pack': 'RewardDownLoadPackEdit',
        'theme_pack': 'RewardThemePackEdit',
        'theme_pack2': 'RewardThemePackEdit',
        'super_collect_pack': 'RewardSerialCollectPack',
        'super_collect_pack2': 'RewardSerialCollectPack',
        'build_partners': 'RewardBuildPartnersEdit',
        'dice_free_spin': 'RewardDiceFreeSpinEdit',
        'pig_bank': 'PigBankEdit',
        'treasure': 'Treasure',
        'invite_help': 'InviteHelp',
        'leapfrog': 'LeapfrogEdit',
        'poster': 'PosterEdit',
        'run_for_it': 'RewardRunForItEdit',
        'airship': 'RewardAirshipEdit',
        'bridge_game': 'RewardBridgeGameEdit',
        'signIn': 'signInEdit',
        'recurrenceGift': 'RecurrenceEdit',
        'time_limited_card': 'time_limited_cardEdit',
        'club_rank': 'rewardClubRankEdit',
        'one_plus_six': 'RewardOnePlusSix',
        'one_plus_six_collect': 'RewardOnePlusSixCollect',
        'mining_rank': 'RewardMiningRankEdit',
        'friend_recall': 'FriendRecallEdit',
        'cooperate_treasure': 'CooperateTreasureEdit',
        'build_discount': 'BuildDiscountEdit',
        'digging_treasure': 'DiggingTreasureEdit',
        'three_gift': 'ThreeGiftEdit',
        'callback': 'CallbackEdit',
        'invite_task': 'InviteTask',
        'carnival': 'CarnivalEdit'
      }

      returnUrl.name = routeMap[type]

      if (!returnUrl.name) {
        this.msgError('无配置')
        return
      }

      this.$router.push(returnUrl)
    },
    del(id, type, priority) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delActivtyCfg({ id: id, name: 0, type: type, data: priority }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    changeOnline(id, status, type, priority) {
      this.$confirm('确认要操作吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeActivtyOnline({ id: id, name: status, type: type, data: priority }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.$store.dispatch('app/clearLocalStorage', { key: 'getPropsActList' })
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    clientFormatter(row) {
      const clientType = ['全部', '安卓', 'IOS']
      return clientType[row.client]
    }, userTypeFormatter(row) {
      const userType = ['全部', 'FB', '游客']
      return userType[row.user_type]
    }, loopTypeFormatter(row) {
      const loopType = ['', '单次', '小时', '天']
      return loopType[row.loop_type ]
    },
    ucTypeFormatter(row) {
      if (row.uc_type === 1) {
        return '道具型活动'
      }
      return '普通活动'
    },
    typeFormatter(row) {
      let name = '未知类型'
      for (const i in this.types) {
        if (row.type === this.types[i].value) {
          name = this.types[i].label
          break
        }
      }
      return name
    },
    importStageCoefficientUploadSuccess(response, aid) {
      this.loading = true
      this.$refs['stage-coefficient'].clearFiles()
      importActivtyStageCoefficientCfg({ id: aid, data: response.data.path }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivtyRewardCfg({ type: this.queryParams.type, id: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportStageCoefficient(id, type) {
      exportStageCoefficientCfg({ id: id, type: type }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(id, type) {
      // console.log('type', type)
      exportActivtyRewardCfg({ id: id, type: type }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
